import { useContext, useEffect } from 'react';
import './systemMessage.css';

import AppContext from '../../../../context/AppProvider';
import CustomSwitch from '../../../../components/CustomSwitch';
import { Button,TextField } from "@mui/material";
import Progress from "@mui/material/CircularProgress";
import BasicModalConfirmation from '../../../../components/basicModalConfirmation';
import { useState } from 'react';
import { useEditConfigsMutation } from '../../../../services/configApi';


const SystemMessage = () => {
  const { config } = useContext(AppContext);
  const [confirmation, setConfirmation] = useState({})
  const [message, setMessage] = useState(null)
  const [updateConfig, { isLoading }] = useEditConfigsMutation()
  const [error, setError] = useState({title:null, message:null})

  useEffect(() => {
    // init message in useEffect to avoid errors
    if (config && !message) {
      setMessage(getMessageFromConfig(config))
      console.log("INIT MESSAGE: ", message)
    }
    return () => {
      // cleanup
      console.log("CLEANUP: ", message)
    }
  }, [])

  function getMessageFromConfig(configuration) {
    let systemMessage = configuration?.find(c => c.name=="systemMessage")?.value
    systemMessage = systemMessage && JSON.parse(systemMessage)
    return systemMessage
  }

  async function handleSaveConfig() {
    let systemMessageConfig = config?.find(c => c.name=="systemMessage")
    try {
      console.log("message before update: ", message)
      let response = await updateConfig([{id:systemMessageConfig.id, value:JSON.stringify(message)}]).unwrap()
      console.log("Update config response: ", response)
      setMessage(getMessageFromConfig(response))
    } catch (error) {
      console.log("error: ", error.message)
      if(error.status == 401) return; //error managed on baseQueryWithReauth 
      throw error
    }
  }

  function handleApplyChanges() {
    if(validateTexts()){
      setConfirmation(
        {
          open:true,
          title:`Are you sure you want to apply these changes?`,
        }
        )
      }
  }

  function handleOncloseClick() {
    setMessage(getMessageFromConfig(config))
    setConfirmation({...confirmation, open:false})
  }

  function handleClose() {
    setConfirmation({...confirmation, open:false})
  }
  
  function handleOnClearMessage() {
    setMessage({...message,title:"",message:""})
  }

  function validateTexts() {
    let error = {title:null, message:null}
    if( message.title == "" && message.message=="") return true
    if (!message?.title) {
      error.title = "Title is required"
    }
    if (!message?.message) {
      error.message = "Message is required"
    }
    if(message.title.length>100){
      error.title = "Title cannot be more than 100 characters"
    }
    if(message.message.length>1000){
      error.message = "Message cannot be more than 1000 characters"
    }
    setError(error)
    return !error.title && !error.message
  }

  const label = { inputProps: { "aria-label": "Switch demo" }, color: "success" };
  
  return ( 
        <>

          {
            <BasicModalConfirmation 
              open={confirmation.open} 
              title={confirmation?.title || "Are you sure?"} 
              confirmLabel="Yes" 
              cancelLabel="No" 
              onClick={handleSaveConfig} 
              handleClose={ handleClose}
              onCloseClick={handleOncloseClick}
              />
          }

          <div className="global-settings-section-div">

            <div style={{ margin: '0 2em 0 0' }} >

              <h4 style={{ fontWeight: '600', margin: '0 0 1em 0' }} >System Message</h4>

              <p style={{ margin: '0 0 1em 0' }}  >
                Message to be shown on the Honeycomb page alone, or on all
                non-Admin pages, when needed.
                <br />
                Message content must be provided and
                the message must be Enable to display.
              </p>

            </div>

            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
              justifyContent: 'space-between',
            }} >
              <div className='switch-label-gs' >
                <label style={{margin:'0 0 0 1em'}} >Enable</label>
                <CustomSwitch 
                  {...label} 
                  label="Enable"
                  checked={message?.enabled} 
                  onChange={
                    ()=>{
                      setMessage({...message, enabled: !message?.enabled})
                      setConfirmation(
                      {
                        open:true,
                        title:`Are you sure you want to ${message?.enabled?'hide':'show'} the entered message?`,
                      }
                      )
                    }
                  }
                  />
              </div>

              <div className='switch-label-gs'>
                <label style={{margin:'0 0 0 1em'}} >Show on all pages</label>
                <CustomSwitch 
                  {...label}
                  checked={message?.showOnAllPages} 
                  onChange={
                    ()=>{
                      setMessage(prev=>({...prev, showOnAllPages: !prev.showOnAllPages })) 
                      setConfirmation(
                      {
                        open:true,
                        title:`Are you sure you want to ${message?.showOnAllPages?'hide':'show'} the entered message on all the non-admin pages?`,
                      }
                      )
                    }
                  }
                  />
              </div>

            </div>

          </div>

          <div className="global-settings-section-div-space-between">

            <div style={{ width: '100%' }}>

              <div className="global-settings-section-texts">

                <label
                  htmlFor="title"
                  style={{width:'100px', margin:'1.25em 0 0 0'}}
                >
                  Title:
                </label>

                <TextField
                  fullWidth={true}
                  multiline={true}
                  name="title"
                  value={message?.title}
                  onChange={(e)=>{
                    setError({title:null, message:null})
                    setMessage({...message,title:e.target.value})
                  }}
                  error={error?.title}
                  helperText={error?.title}
                />

              </div>

              <div className="global-settings-section-texts">

                <label htmlFor="message" style={{width:'100px', margin:'1.25em 0 0 0'}} >Message: </label>
                <TextField 
                  fullWidth={true} 
                  multiline={true}
                  name="message" 
                  value={message?.message}
                  onChange={(e)=>{
                    setError({title:null, message:null})
                    setMessage({...message,message:e.target.value})
                  }}
                  error={error?.message}
                  helperText={error?.message}
                  rows={4} 
                />
              
              </div>

            </div>

            <div className="special-message-text-buttons">

              <Button 
                onClick={handleApplyChanges} 
                disabled={isLoading || error.title || error.message } variant="contained" 
              >
                {isLoading ?<Progress/>:"Apply Changes"}
              </Button>

              <Button variant="contained" onClick={handleOnClearMessage} color="secondary">
                Clear Message
              </Button>

            </div>

          </div>
        </>
  );
}
 
export default SystemMessage;